import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils/cn';

interface Props {
  elapsedMinutes: number;
  onResume: () => void;
  onDiscard: () => void;
}

export const SessionRecoveryBanner: React.FC<Props> = ({ elapsedMinutes, onResume, onDiscard }) => {
  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4',
        'bg-card border border-border rounded-xl px-4 py-3 shadow-sm',
        'mx-4 sm:mx-0 mb-4'
      )}
      role="alert"
    >
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-foreground">
          Session recovered &mdash;{' '}
          <span className="text-primary font-semibold">{elapsedMinutes} min</span> of work saved.
          {' '}Timer is paused.
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Resume to continue where you left off, or discard to start fresh.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          onClick={onResume}
          className="h-8 px-4 text-xs font-semibold"
        >
          Resume
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onDiscard}
          className="h-8 px-4 text-xs font-medium text-muted-foreground hover:text-foreground"
        >
          Discard
        </Button>
      </div>
    </div>
  );
};
